import snakecaseKeys from 'snakecase-keys'
import { serialize } from 'object-to-formdata'
import axiosIns from '@/plugins/axios'

export default {
  getCustomers(params = {}) {
    return axiosIns.get(
      '/waiter/customers',
      {
        params: snakecaseKeys(params),
      },
    )
  },

  getCustomer(id) {
    return axiosIns.get(`/waiter/customers/${id}`)
  },

  createCustomer(params) {
    const customerData = {
      name: params.name,
      customerTagIds: params.customerTagIds || [],
    }
    const formData = serialize(snakecaseKeys({ customer: customerData }))

    return axiosIns.post('/waiter/customers', formData)
  },

  updateCustomer(id, params) {
    const customerData = {
      name: params.name,
      customerTagIds: params.customerTagIds || [],
    }
    const formData = serialize(snakecaseKeys({ customer: customerData }))

    return axiosIns.put(`/waiter/customers/${id}`, formData)
  },

  deleteCustomer(id) {
    return axiosIns.delete(`/waiter/customers/${id}`)
  },

  getVisitHistory(id) {
    return axiosIns.get(`/waiter/customers/${id}/visit_history`)
  },
}
